import { render, staticRenderFns } from "./backdrop.svg.vue?vue&type=template&id=0d124b98&"
import script from "./backdrop.svg.vue?vue&type=script&lang=js&"
export * from "./backdrop.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports